/**
 * City Constants
 * Domain-specific constants and configuration
 */

// ===========================================
// Status Configuration
// ===========================================

export const CITY_STATUS_CONFIG = {
  active: {
    label: 'Active',
    color: 'emerald',
    bgClass: 'bg-emerald-100 dark:bg-emerald-900/30',
    textClass: 'text-emerald-600 dark:text-emerald-400',
  },
  inactive: {
    label: 'Inactive',
    color: 'slate',
    bgClass: 'bg-slate-100 dark:bg-slate-800',
    textClass: 'text-slate-600 dark:text-slate-400',
  },
} as const

// ===========================================
// Default Values
// ===========================================

export const DEFAULT_CITY_FILTER = {
  isActive: 'all' as const,
  search: '',
}

export const DEFAULT_CITY_STATS = {
  total: 0,
  active: 0,
  inactive: 0,
  byRegion: {} as Record<string, number>,
}

// ===========================================
// Pagination
// ===========================================

export const DEFAULT_PAGE_SIZE = 20
export const CITY_PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

// ===========================================
// Form Field Names
// ===========================================

export const CITY_FIELDS = {
  CODE: 'code',
  NAME: 'name',
  STATE_PROVINCE: 'stateProvince',
  SALES_DISTRICT: 'salesDistrict',
  IS_ACTIVE: 'isActive',
  REGION_ID: 'regionId',
  COUNTRY_ID: 'countryId',
} as const

// ===========================================
// Translation Keys
// ===========================================

export const T_KEYS = {
  CITIES: {
    TITLE: 'cities.title',
    SUBTITLE: 'cities.subtitle',
    ADD_CITY: 'cities.addCity',
    EDIT_CITY: 'cities.editCity',
    DELETE_CITY: 'cities.deleteCity',
    FORM: {
      CODE: 'cities.form.code',
      CODE_PLACEHOLDER: 'cities.form.codePlaceholder',
      NAME: 'cities.form.name',
      NAME_PLACEHOLDER: 'cities.form.namePlaceholder',
      STATE_PROVINCE: 'cities.form.stateProvince',
      STATE_PROVINCE_PLACEHOLDER: 'cities.form.stateProvincePlaceholder',
      SALES_DISTRICT: 'cities.salesDistrict',
      SALES_DISTRICT_PLACEHOLDER: 'cities.salesDistrictPlaceholder',
      REGION: 'cities.form.region',
      SELECT_REGION: 'cities.form.selectRegion',
      COUNTRY: 'cities.form.country',
      SELECT_COUNTRY: 'cities.form.selectCountry',
      IS_ACTIVE: 'cities.form.isActive',
    },
    VALIDATION: {
      CODE_REQUIRED: 'cities.validation.codeRequired',
      NAME_REQUIRED: 'cities.validation.nameRequired',
      REGION_REQUIRED: 'cities.validation.regionRequired',
    },
    STATS: {
      TOTAL: 'cities.stats.total',
      ACTIVE: 'cities.stats.active',
      INACTIVE: 'cities.stats.inactive',
    },
  },
  COMMON: {
    SAVE: 'common.save',
    CANCEL: 'common.cancel',
    DELETE: 'common.delete',
    LOADING: 'common.loading',
    SEARCH: 'common.search',
    FILTER: 'common.filter',
    ALL: 'common.all',
    ACTIVE: 'common.active',
    INACTIVE: 'common.inactive',
  },
} as const
